import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./style.module.css";
import { InputText, IntegerNumber, Currency } from "../Input";
import DatePicker from "../DatePicker";
import useCostCenter from "../../hooks/api/useCostCenter";
import Slct from "../Slct";
import Button from "../Button";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";
import TableResponsive from "../TableResponsive";
import Checkbox from "../Checkbox";
import useSuppliers from "../../hooks/api/useSuppliers";
import Loading from "../Loading";
import Results from "../Results";
import useFormat from "../../hooks/utils/useFormat";
import Required from "../../components/Required";
import { validateForm, validateStyle } from "../../components/ValidateForm";
import ModalCustom from "./modal-template-default";

export default function ModalProduct(props) {
  const { show, productPreLoad: product_pre_load, commercial, closeModal, reload, isProduct, payerPreLoad } = props;
  const { config, me } = useWrapper();
  const { formatReal, stringToDate } = useFormat();
  const [loading, setloading] = useState();

  const _events = commercial?.packages_data?.events?.map(__event => ({
    label: __event.name,
    value: __event.id,
    resources: __event.resources.map(__resource => ({
      label: __resource.name,
      value: __resource.resource_id,
    })),
  }));

  const [payer, setpayer] = useState(payerPreLoad);

  const costCenter = useCostCenter({ query: "?type=receita" });
  const [product, setproduct] = useState();
  useEffect(() => {
    if (product_pre_load) {
      setproduct({
        id: product_pre_load?.id,
        cost_center: product_pre_load?.cost_center_id,
        expense_plan: product_pre_load?.expense_plan_id,
        expense: product_pre_load?.expense_id,
        name: product_pre_load?.name,
        description: product_pre_load?.description,
        event: product_pre_load?.event_id,
        amount: product_pre_load?.quantity,
        date_start: stringToDate(product_pre_load?.date_start),
        date_end: stringToDate(product_pre_load?.date_end),
        price: product_pre_load?.value,
        fee: product_pre_load?.convenience_fee,
        trainee_payer: { value: product_pre_load?.trainees?.id },
        payment_type: product_pre_load?.type_payment,
        payment_method: product_pre_load?.method_payment,
        quota: product_pre_load?.quotas,
        resource: product_pre_load?.resource_id,
        contribution_value: product_pre_load?.contribution_value,
      });
    } else {
      setproduct();
    }
  }, [product_pre_load]);

  const submitProduct = async () => {
    const _is_valid = validateForm(document.getElementById("form_container"));
    if (!_is_valid) return;

    let data;
    if (payer === "produto") {
      data = {
        payer_type: "produto",
        commercial_id: commercial.id,
        ...(product?.id ? { id: product?.id } : {}),
        cost_center_id: product?.cost_center,
        expense_plan_id: product?.expense_plan,
        expense_id: product?.expense,
        date_start: product?.date_start,
        date_end: product?.date_end,
        value: product?.price,
        convenience_fee: product?.fee,
        contribution_value: product?.contribution_value,
        name: product?.name,
        description: product?.description,
        quantity: product?.amount,
        event_id: product?.event,
        resource_id: product?.resource,
      };
    } else if (payer === "formando") {
      data = {
        payer_type: "formando",
        commercial_id: commercial.id,
        ...(product?.id ? { id: product?.id } : {}),
        trainees:
          product?.trainee_payer?.length > 0
            ? product?.trainee_payer?.map(__trainee => __trainee.value)
            : [product?.trainee_payer?.value],
        cost_center_id: product?.cost_center,
        expense_plan_id: product?.expense_plan,
        expense_id: product?.expense,
        name: product?.name,
        description: product?.description,
        value: product?.price,
        convenience_fee: product?.fee,
        contribution_value: product?.contribution_value,
        type_payment: product?.payment_type,
        method_payment: product?.payment_method,
        quantity: product?.amount,
        event_id: product?.event,
        resource_id: product?.resource,
        quotas: product?.quota,
        payments: product?.quotas?.map((__quota, __quota_i) => ({
          type_payment: product?.payment_method,
          value: __quota?.price,
          value_raw: __quota?.price,
          due_date: __quota?.due_date,
          description: null,
          quotas: __quota_i + 1,
          total_quotas: product?.quota,
          entry: false,
          editable: false,
          commercial_id: commercial.id,
          cost_center_id: product?.cost_center,
          expense_plan_id: product?.expense_plan,
          expense_id: product?.expense,
          status: "nao-gerado",
          label: __quota?.label,
        })),
      };
    }
    setloading(true);
    if (product?.id) {
      try {
        await api.put(`custom-payment/${product?.id}`, data, config);
        if (payer === "produto") {
          toast.success("Produto Atualizado com Sucesso!");
          api.post(
            "activity",
            {
              message: `Produto ${product?.name} atualizado`,
              user_id: me.id,
              commercial_id: commercial.id,
              type: "act",
            },
            config,
          );
        } else {
          toast.success("Cobrança Atualizado com Sucesso!");
        }
      } catch (__err) {
        console.log("__err", __err);
      }
    } else {
      try {
        await api.post("custom-payment", data, config);
        if (payer === "produto") {
          toast.success("Produto Cadastrado com Sucesso!");
          api.post(
            "activity",
            {
              message: `Produto ${product?.name} disponibilizado`,
              user_id: me.id,
              commercial_id: commercial.id,
              type: "act",
            },
            config,
          );
        } else {
          toast.success("Cobrança Cadastrada com Sucesso!");
        }
      } catch (__err) {
        console.log("__err", __err);
      }
    }
    setloading(false);
    reload();
    closeModal();
    setproduct();
  };

  useEffect(() => {
    if (!isProduct && product?.price && product?.quota && product?.first_pay) {
      let _quotas = [];
      for (let i = 0; i < product?.quota; i++) {
        let _due_date = stringToDate(product?.first_pay);
        if (product?.interval) {
          _due_date = stringToDate(_due_date.setDate(_due_date.getDate() + product?.interval * i));
        } else {
          _due_date = stringToDate(_due_date.setMonth(_due_date.getMonth() + i));
        }
        _quotas.push({
          label: `${i + 1}/${product?.quota}`,
          price:
            ((((product?.price || 0) + (product?.contribution_value || 0)) * product?.amount || 0) +
              (product?.fee || 0)) /
            product?.quota,
          due_date: _due_date,
          description: "",
        });
      }
      setproduct({
        ...product,
        quotas: _quotas,
      });
    }
  }, [
    product?.price,
    product?.contribution_value,
    product?.amount,
    product?.fee,
    product?.quota,
    product?.first_pay,
    product?.interval,
  ]);

  const { data: supplier_data, load: loadSuppliers } = useSuppliers();
  const _supliers = supplier_data?.map(__supplier => ({
    value: __supplier.id,
    label: __supplier.name,
  }));

  useEffect(() => {
    if (payer === "fornecedor" && !_supliers) {
      loadSuppliers();
    }
  }, [payer]);

  return (
    <ModalCustom size="lg" show={show} onHide={closeModal} centered id="form_container">
      <ModalCustom.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">
            {product_pre_load
              ? product?.name || "Nome Produto"
              : `Adicionar Nov${isProduct ? "o Produto" : "a Cobrança"}`}
          </h2>
        </div>
      </ModalCustom.Header>
      <ModalCustom.Body>
        {!isProduct && (
          <>
            {!payerPreLoad && (
              <Row className="mb-3">
                <Col>
                  <label>
                    Tipo de Pagador <Required />
                  </label>
                  <Slct
                    required={true}
                    options={[
                      { value: "formando", label: "Formando" },
                      { value: "fornecedor", label: "Fornecedor" },
                      { value: "custom", label: "Outro" },
                    ]}
                    value={payer}
                    onChange={__e => {
                      setpayer(__e.value);
                      setproduct({
                        ...product,
                        trainee_payer: null,
                        supplier_payer: null,
                        quota: 1,
                      });
                    }}
                    placeholder="..."
                  />
                </Col>
              </Row>
            )}
            {payer === "formando" && !!commercial?.trainees?.length && (
              <Row className="mb-3">
                <Col>
                  {!product_pre_load ? (
                    <>
                      <label>
                        Formando(s) <Required />
                      </label>
                      <Slct
                        required={true}
                        isMulti="true"
                        options={
                          [
                            {
                              value: "<SELECT_ALL>",
                              label: "-- Marcar Todos --",
                            },
                          ].concat(
                            commercial?.trainees?.map(__trainee => ({
                              label: __trainee.name,
                              value: __trainee.id,
                            })),
                          ) || []
                        }
                        value={product?.trainee_payer || []}
                        onChange={__e => {
                          setproduct({
                            ...product,
                            trainee_payer: __e,
                          });
                        }}
                        placeholder="..."
                      />
                    </>
                  ) : (
                    <>
                      <label>
                        Formando <Required />
                      </label>
                      <Slct
                        required={true}
                        isDisabled={true}
                        options={
                          commercial?.trainees?.map(__trainee => ({
                            label: __trainee.name,
                            value: __trainee.id,
                          })) || []
                        }
                        value={product?.trainee_payer.value}
                        onChange={__e => {
                          setproduct({
                            ...product,
                            trainee_payer: __e,
                          });
                        }}
                        placeholder="..."
                      />
                    </>
                  )}
                </Col>
              </Row>
            )}
            {payer === "fornecedor" && (
              <Row className="mb-3">
                <Col>
                  <label>
                    Fornecedor <Required />
                  </label>
                  {!!_supliers ? (
                    <Slct
                      required={true}
                      options={_supliers || []}
                      value={product?.supplier_payer}
                      onChange={__e => {
                        setproduct({
                          ...product,
                          supplier_payer: __e.value,
                        });
                      }}
                      placeholder="..."
                    />
                  ) : (
                    <Loading small={true} />
                  )}
                </Col>
              </Row>
            )}
            {payer === "custom" && (
              <Row className="mb-3">
                <Col>
                  <label>
                    Pagador <Required />
                  </label>
                  <InputText
                    required={true}
                    value={product?.custom_payer}
                    onChange={__e => {
                      setproduct({
                        ...product,
                        custom_payer: __e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
            )}
          </>
        )}
        <Row className="mb-3">
          <Col>
            <label>
              Centro de Custo <Required />
            </label>
            <Slct
              required={true}
              options={costCenter || []}
              value={product?.cost_center}
              onChange={__e => {
                setproduct({
                  ...product,
                  cost_center: __e.value,
                  expense_plan: null,
                  expense: null,
                });
              }}
              placeholder="..."
            />
          </Col>
          <Col>
            <label>
              Plano de Conta <Required />
            </label>
            <Slct
              required={true}
              options={
                costCenter?.find(__cost_center => __cost_center.value === product?.cost_center)?.expensePlan || []
              }
              value={product?.expense_plan}
              onChange={__e => {
                setproduct({
                  ...product,
                  expense_plan: __e.value,
                  expense: null,
                });
              }}
              placeholder="..."
            />
          </Col>
          <Col>
            <label>
              Conta <Required />
            </label>
            <Slct
              required={true}
              options={
                costCenter
                  ?.find(__cost_center => __cost_center.value === product?.cost_center)
                  ?.expensePlan?.find(__expense_plan => __expense_plan.value === product?.expense_plan)?.expenses || []
              }
              value={product?.expense}
              onChange={__e => {
                setproduct({
                  ...product,
                  expense: __e.value,
                });
              }}
              placeholder="..."
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <label>
              Nome d{isProduct ? "o Produto" : "a Cobrança"} <Required />
            </label>
            <InputText
              required={true}
              value={product?.name}
              onChange={__e => {
                setproduct({
                  ...product,
                  name: __e.target.value,
                });
              }}
            />
          </Col>
          <Col>
            <label>Evento</label>
            <Slct
              options={[{ value: null, label: "-- Todos --" }].concat(_events || []) || []}
              value={product?.event}
              onChange={__e => {
                setproduct({
                  ...product,
                  event: __e.value,
                  resource: null,
                });
              }}
              placeholder="..."
            />
          </Col>
          <Col>
            <label>Recurso</label>
            <Slct
              options={_events?.find(__event => __event.value === product?.event)?.resources || []}
              value={product?.resource}
              onChange={__e => {
                setproduct({
                  ...product,
                  resource: __e.value,
                });
              }}
              placeholder="..."
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <label>Descrição</label>
            <InputText
              value={product?.description}
              onChange={__e => {
                setproduct({
                  ...product,
                  description: __e.target.value,
                });
              }}
            />
          </Col>
        </Row>
        {!!isProduct && (
          <Row className="mb-3">
            <Col>
              <label>
                Data Início <Required />
              </label>
              <DatePicker
                required={true}
                selected={product?.date_start}
                changeDate={__e => {
                  setproduct({
                    ...product,
                    date_start: __e,
                    ...(!product?.date_end ? { date_end: __e } : {}),
                  });
                }}
              />
            </Col>
            <Col>
              <label>
                Data Encerramento <Required />
              </label>
              <DatePicker
                required={true}
                selected={product?.date_end}
                changeDate={__e => {
                  setproduct({
                    ...product,
                    date_end: __e,
                  });
                }}
              />
            </Col>
          </Row>
        )}
        <Row className="mb-3">
          <Col>
            <label>
              Valor <Required /> <span className="small-label">(Por Unidade)</span>
            </label>
            <Currency
              required={true}
              disabled={payer !== "produto" && !!product_pre_load}
              value={product?.price}
              valueChange={__e => {
                setproduct({
                  ...product,
                  price: __e,
                });
              }}
            />
          </Col>

          <Col>
            <label>
              Aporte <span className="small-label">(Por Unidade)</span>
            </label>
            <Currency
              disabled={payer !== "produto" && !!product_pre_load}
              value={product?.contribution_value}
              valueChange={__e => {
                setproduct({
                  ...product,
                  contribution_value: __e,
                });
              }}
            />
          </Col>
          <Col>
            <label>
              {!!isProduct ? "Disponibilidade" : "Quantidade"} <Required />
            </label>
            <IntegerNumber
              required={true}
              disabled={payer !== "produto" && !!product_pre_load}
              value={product?.amount}
              valueChange={__e => {
                setproduct({
                  ...product,
                  amount: Number(__e),
                });
              }}
            />
          </Col>
          <Col>
            <label>Taxa de Conveniência</label>
            <Currency
              disabled={payer !== "produto" && !!product_pre_load}
              value={product?.fee}
              valueChange={__e => {
                setproduct({
                  ...product,
                  fee: __e,
                });
              }}
            />
          </Col>
        </Row>
        {!isProduct && (
          <>
            <Row className="mb-3">
              <Col>
                <label>
                  Tipo de Pagamento <Required />
                </label>
                <Slct
                  required={true}
                  isDisabled={payer !== "produto" && !!product_pre_load}
                  options={[
                    { value: "avista", label: "À Vista" },
                    { value: "parcelado", label: "A Prazo / Parcelado" },
                  ]}
                  value={product?.payment_type}
                  onChange={__e => {
                    setproduct({
                      ...product,
                      payment_type: __e.value,
                      quota: 1,
                      first_pay: new Date(),
                    });
                  }}
                  placeholder="..."
                />
              </Col>
              {!!product?.payment_type && (
                <Col>
                  <label>
                    Método de Pagamento <Required />
                  </label>
                  <Slct
                    required={true}
                    isDisabled={payer !== "produto" && !!product_pre_load}
                    options={[
                      { value: "pix", label: "PIX" },
                      { value: "boleto", label: "Boleto" },
                      { value: "cartao", label: "Cartão" },
                      { value: "especie", label: "Espécie" },
                    ]}
                    value={product?.payment_method}
                    onChange={__e => {
                      setproduct({
                        ...product,
                        payment_method: __e.value,
                      });
                    }}
                    placeholder="..."
                  />
                </Col>
              )}
              {product?.payment_type === "parcelado" && (
                <Col>
                  <label>
                    Parcelamento <Required />
                  </label>
                  <IntegerNumber
                    required={true}
                    disabled={payer !== "produto" && !!product_pre_load}
                    value={product?.quota}
                    valueChange={__e => {
                      setproduct({
                        ...product,
                        quota: __e,
                      });
                    }}
                  />
                </Col>
              )}
            </Row>
            {product?.payment_type === "parcelado" && !product_pre_load && (
              <Row className="mb-3">
                <Col>
                  <label>
                    Primeiro Pagamento <Required />
                  </label>
                  <DatePicker
                    required={true}
                    selected={product?.first_pay}
                    changeDate={__e => {
                      setproduct({
                        ...product,
                        first_pay: __e,
                      });
                    }}
                  />
                </Col>
                <Col style={{ position: "relative" }}>
                  <label>
                    Intervalo <Required />
                  </label>
                  <label className="im-checkbox pr-3">
                    <Checkbox
                      checked={!!product?.interval}
                      onChange={__e => {
                        setproduct({
                          ...product,
                          interval: __e.target.checked ? 30 : null,
                        });
                      }}
                    />
                    <span className="lince-input_label fs-12">Em Dias</span>
                  </label>
                  {!!product?.interval ? (
                    <IntegerNumber
                      value={product?.interval}
                      onBlur={__e => {
                        setproduct({
                          ...product,
                          interval: Number(__e.target.value || 0),
                        });
                      }}
                      valueChange={__e => {
                        __e &&
                          setproduct({
                            ...product,
                            interval: Number(__e),
                          });
                      }}
                    />
                  ) : (
                    <InputText value={"Mensal"} disabled={true} />
                  )}
                </Col>
              </Row>
            )}
          </>
        )}
        {!(payer !== "produto" && !!product_pre_load) && (
          <>
            {!isProduct && !!product?.price && product?.payment_type && (
              <Row className="mt-4">
                <Col>
                  <TableResponsive
                    table={{
                      head: [{ data: "" }, { data: "Valor" }, { data: "Vencimento" }, { data: "Descrição" }],
                      body:
                        product?.quotas?.map((__quota, __quota_i) => ({
                          data: [
                            {
                              element: <span style={{ whiteSpace: "nowrap" }}>{__quota.label}</span>,
                            },
                            {
                              element: <Currency disabled={true} value={__quota.price || ""} valueChange={() => {}} />,
                            },
                            {
                              element: (
                                <DatePicker
                                  selected={__quota.due_date}
                                  dateFormat={"dd/MM/yyyy"}
                                  placeholder={"--/--/----"}
                                  changeDate={__e => {
                                    let _quotas = [...product?.quotas];
                                    _quotas[__quota_i].due_date = __e;
                                    setproduct({
                                      ...product,
                                      quotas: _quotas,
                                    });
                                  }}
                                  minDate={new Date()}
                                />
                              ),
                            },
                            {
                              element: (
                                <InputText
                                  value={__quota.description}
                                  onChange={__e => {
                                    let _quotas = [...product?.quotas];
                                    _quotas[__quota_i].description = __e.target.value;
                                    setproduct({
                                      ...product,
                                      quotas: _quotas,
                                    });
                                  }}
                                />
                              ),
                            },
                          ],
                        })) || [],
                    }}
                  />
                </Col>
              </Row>
            )}
          </>
        )}
        <Row className="text-right">
          <Col md={{ span: 7, offset: 5 }}>
            {!isProduct ? (
              <Results
                rows={[
                  {
                    label: (
                      <>
                        Valor <span className="small-label">(Por Unidade)</span>
                      </>
                    ),
                    value: `+ ${formatReal(product?.price || 0)}`,
                    type: "dark",
                  },
                  {
                    label: (
                      <>
                        Aporte <span className="small-label">(Por Unidade)</span>
                      </>
                    ),
                    value: `+ ${formatReal(product?.contribution_value || 0)}`,
                  },
                  {
                    label: "Quantidade",
                    value: `x ${product?.amount || 0}`,
                  },
                  {
                    label: "Taxa de Conveniência",
                    value: `+ ${formatReal(product?.fee || 0)}`,
                  },
                  {
                    label: <b>Total</b>,
                    value: (
                      <b>
                        {formatReal(
                          ((product?.price || 0) + (product?.contribution_value || 0)) * product?.amount +
                            (product?.fee || 0) || 0,
                        )}
                      </b>
                    ),
                    type: true ? "dark" : "",
                  },
                ]}
              />
            ) : (
              <Results
                rows={[
                  {
                    label: (
                      <>
                        Valor <span className="small-label">(Por Unidade)</span>
                      </>
                    ),
                    value: formatReal(product?.price || 0),
                  },
                  {
                    label: (
                      <>
                        Aporte <span className="small-label">(Por Unidade)</span>
                      </>
                    ),
                    value: formatReal(product?.contribution_value || 0),
                  },
                  {
                    label: (
                      <b>
                        Total <span className="small-label">(Por Unidade)</span>
                      </b>
                    ),
                    value: <b>{formatReal((product?.price || 0) + (product?.contribution_value || 0))}</b>,
                    type: true ? "dark" : "",
                  },
                  {
                    label: (
                      <>
                        + Taxa de Conveniência <span className="small-label">(Por Transação)</span>
                      </>
                    ),
                    value: formatReal(product?.fee || 0),
                  },
                ]}
              />
            )}
          </Col>
        </Row>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button onClick={submitProduct} loading={loading}>
          {product_pre_load ? "Atualizar " : "Adicionar "}
          {isProduct ? "Produto" : "Cobrança"}
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
}
